const baseURL = process.env.NODE_ENV === 'production' 
  ? process.env.REACT_APP_API_BASE_URL || 'https://app.autoyad.ir' 
  : process.env.REACT_APP_API_BASE_URL || 'https://localhost:7114';

export const BASE_URL = baseURL;
// var backend = "json";
// var backend='api-local'
// var backend='api'

// export let BASE_URL;

// switch (backend) {
//   case "json":
//     BASE_URL = "http://localhost:3001"; //====> json db
//     break;

//   case "api-local":
//     BASE_URL = "https://localhost:7114"; //====> local db
//     break;

//   case "api":
//     BASE_URL = "/"; //====> online db
//     break;

//   default:
//     BASE_URL = "http://localhost:3001"; //====> json db
//     break;
// }

// export const carInit = {
//   // id: "",
//   title: '',
//   pelak1: '',
//   pelak2: 1,
//   pelak3: '',
//   pelak4: '',
//   shasiNo: '',
//   productYear: '',
//   kilometer: '',
//   useFuel: '',
//   company: '',
//   distancePerWeek: '',
//   userId: null,
//   imageUrl: "",
// };

export let GET_ALL_CARS;
export let DELETE_CAR;
export let GET_CAR;
export let PUT_CAR;
export let POST_CAR;
export let FILL_WORK_SERVICE;
export let OPERATE_CAR_OPERKIND;
export let OPERATE_FILTER;
export let OPERATE_INSERT;
export let OPERATE_UPDATE;
export let GET_TOP_OPERATE;
export let FILL_CALENDAR_SERVICE;
export let FILL_OPERDON_SOME_RECORE;
export let FILL_OPERDON_PAGING;
export let OPERKIND_CAR;
export let OPERDONE_INSERT;
export let OPERDON_PAGING;
export let OPERDON_DELET;
export let OPERDONE_UPDATE;
export let OTP_SEND;
export let OTP_VERIFIED;
export let LOGIN;
export let CHANGE_PASS;
export let FORGOTPASS;
export let OTP_VERIFIED_FORGOT;
export let OTP_SEND_FORGOT;
export let PROTECTED;
export let GET_USER;
export let UPDATE_KILOMETER;
export let USER_SUBSCRIPTION;
export let BAZAAR_INITPAYMENT;
export let BAZAAR_VERIFYPAYMENT;


GET_ALL_CARS = "/api/Cars";
DELETE_CAR = "/api/Cars/";
GET_CAR = "/api/Cars/";
PUT_CAR = "/api/Cars/";
POST_CAR = "/api/Cars";
UPDATE_KILOMETER = "/api/Cars/EditKilometer";

FILL_WORK_SERVICE = "api/Operate/GetWithType";
OPERATE_CAR_OPERKIND = "api/Operate";
OPERATE_FILTER = "api/Operate/GetFilter";
FILL_CALENDAR_SERVICE = "api/Operate/GetWithType?serviceType=time";
OPERATE_INSERT = "api/Operate";
OPERATE_UPDATE = "api/Operate";
GET_TOP_OPERATE = "api/Operate/GetTop";

FILL_OPERDON_SOME_RECORE="api/Operdon?count=20";
FILL_OPERDON_PAGING="api/Operdon/GetPaging?page=1&itemCount=10";

OPERKIND_CAR="api/Operkinds";

OPERDONE_INSERT = "api/Operdon";
OPERDON_PAGING = "api/Operdon/GetPaging";
OPERDON_DELET = "api/Operdon";
OPERDONE_UPDATE = "api/Operdon";

OTP_SEND = "api/Authenticate/register";
OTP_VERIFIED = "api/Authenticate/VerifyRegister";
LOGIN = "api/Authenticate/login";
PROTECTED = "api/Authenticate/protected";

OTP_SEND_FORGOT = "api/Authenticate/forgotPass";//1
OTP_VERIFIED_FORGOT = "api/Authenticate/verifyOtpForgotPass";//2
FORGOTPASS = "api/Authenticate/changeForgotPass";//3
CHANGE_PASS = "api/Authenticate/changepass";
GET_USER = "api/Users/";

USER_SUBSCRIPTION = "api/Users/Subscriptions/";
BAZAAR_INITPAYMENT = "api/payment/init/";
BAZAAR_VERIFYPAYMENT = "api/Payment/verify/";


